<div [class]="'action-form-wrapper d-flex' + (formClass ? ' ' + formClass : '')">
  @if (formTitle) {
    <h5>{{formTitle | translate}}</h5>
  }
  @for (action of actions; track action) {
    @if (!isHidden(action)) {
      <button [class]="'btn' + classResolver(action)" (click)="clickHandler($event, action)"
        [disabled]="isDisabled(action)">
        {{ action.text | translate }}@if (hasIcon(action)) {
        <i [class]="'now-ui-icons ' + iconResolver(action)"></i>
      }
    </button>
  }
}
</div>